import { BadgeVariant, DotVariants } from "@/shared/components";
import { EnumTypeValue } from "@/shared/types";

export const VestigingStatus = {
    BESTELD: "Besteld",
    ACTIEF: "Actief",
    STOP_AANGEVRAAGD: "StopAangevraagd",
    GESTOPT: "Gestopt",
    GAAT_NIET_LEVEREN: "GaatNietLeveren",
} as const;

export type VestigingStatus = EnumTypeValue<typeof VestigingStatus>;

export const vestigingStatusMap = {
    Besteld: { label: "Besteld", dotVariant: "info", badgeVariant: "blue-subtle" },
    Actief: { label: "Actief", dotVariant: "succes", badgeVariant: "green-subtle" },
    StopAangevraagd: { label: "Stop aangevraagd", dotVariant: "warning", badgeVariant: "yellow-subtle" },
    GaatNietLeveren: { label: "Gaat niet leveren", dotVariant: "neutral", badgeVariant: "red-subtle" },
    Gestopt: { label: "Gestopt", dotVariant: "neutral", badgeVariant: "red-subtle" },
} satisfies Record<VestigingStatus, { label: string; dotVariant: DotVariants["variant"]; badgeVariant: BadgeVariant }>;

export const VerlengingStatus = {
    AANGEVRAAGD: "Aangevraagd",
    ACTIEF: "Actief",
    AFGEWEZEN: "Afgewezen",
    GESTOPT: "Gestopt",
} as const;

export type VerlengingStatus = EnumTypeValue<typeof VerlengingStatus>;

export const VestigingBeschikbareFaciliteiten = {
    KOFFIE_THEE: "KoffieThee",
    TOILET: "Toilet",
} as const;

export type VestigingBeschikbareFaciliteiten = EnumTypeValue<typeof VestigingBeschikbareFaciliteiten>;

export const VESTIGINGEN_QUERY_KEY = "vestigingen";
export const AANGEVRAADGE_LANDELIJKE_FACILITEITEN_QUERY_KEY = "landelijke-faciliteiten";
